import { MouseEvent, ReactElement, useState } from 'react';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { CoreProps } from '../types';
import styles from './simple-tooltip.module.scss';

interface SimpleTooltipProps extends CoreProps {
    message: string;
}

const SimpleTooltip = ({ children, message, className }: SimpleTooltipProps): ReactElement => {
    const [xMousePosition, setXMousePosition] = useState<number>();
    const [yMousePosition, setYMousePosition] = useState<number>();
    const [displayTooltip, setDisplayTooltip] = useState<boolean>(false);

    function showTooltip(dom: MouseEvent): void {
        dom.preventDefault();
        switch (dom.type) {
            case 'click':
                setXMousePosition(Math.max(0, dom.clientX - 250));
                setYMousePosition(dom.clientY + 10);
                setDisplayTooltip(!displayTooltip);
                break;

            case 'mouseleave':
                setDisplayTooltip(false);
                break;
        }
    }

    return (
            <a href="#" onMouseLeave={showTooltip} onClick={showTooltip} className={[styles.container, className].filter(Boolean).join(' ')}>
                <div>{children}</div>
                <Icon variant={IconsEnum.INFO} />
                {displayTooltip && (
                    <div className={styles.tooltip} style={{ top: yMousePosition, left: xMousePosition }} dangerouslySetInnerHTML={{__html: message}}/>
                )}
            </a>
        );
};

export default SimpleTooltip;
